import { ref } from "@nuxtjs/composition-api";
import { defineStore } from "pinia";

import { useAxios } from "@/composables";
import SignedPoliciesApi from "@/store/signed-policies/-api";

export const useSignedPoliciesStore = defineStore("signed-policies", () => {
  // Variables
  const axios = useAxios();

  // State
  const signedPolicies = ref<SignedPolicies | null>(null);

  // Actions
  const fetchSignedPolicies = async () => {
    const api = new SignedPoliciesApi(axios);
    const response = await api.get();

    setSignedPolicies(response.data.signedPolicies);
  };

  const updateSignedPolicies = async (signedPolicies: SignedPoliciesPatchData) => {
    const api = new SignedPoliciesApi(axios);
    const response = await api.patch(signedPolicies);

    setSignedPolicies(response.data.signedPolicies);
  };

  const setSignedPolicies = (policies: Partial<SignedPolicies>) => {
    signedPolicies.value = Object.assign({}, signedPolicies.value, policies);
  };

  const resetStore = () => {
    signedPolicies.value = null;
  };

  return {
    signedPolicies,
    fetchSignedPolicies,
    updateSignedPolicies,
    setSignedPolicies,
    resetStore,
  };
});
